import { render } from "./Crew.vue?vue&type=template&id=d3338ea2&scoped=true"
import script from "./Crew.vue?vue&type=script&lang=js"
export * from "./Crew.vue?vue&type=script&lang=js"

import "./Crew.vue?vue&type=style&index=0&id=d3338ea2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3338ea2"]])

export default __exports__